import { get, isEmpty, isNull } from "lodash-es";
import React, { useContext, useEffect, useState } from "react";
import { useRequest } from "../../../abstracts";
import { LoaderWrapper, ManageMapperLayout } from "../../../components";
import { CsplTable as Table } from "../../../components";
import {
  manageMapperStore,
  MANAGE_MAPPER_POST_API_ERROR,
} from "../../../contexts";
import { verifyMapService } from "../../../services";
import { getPathWithParam, MANAGE_MAPPER_ROUTES, ROUTES } from "../../../utils";
import { useRouterParams } from "../../../abstracts";
import { render } from "@testing-library/react";
import { isArray } from "lodash";
import { Tab } from "react-bootstrap";

const propertyNames = [
  "EmployeeClassifications",
  "Compensations",
  "Contributions",
  "PayrollLoans",
  "ServiceRecords",
  "PayrollFrequencies",
  "EmploymentStatuses",
  "PayrollCalendars",
  "Sources",
  "Sponsors",
  "Trustees",
  "ClearingPartners",
  "Advisors",
  "Investments",
  "Eligibility",
  "EntryDate",
  "Vesting",
  "Loans",
  "Distributions",
  "Address",
  "Contact",
  "IncorporationDetail",
  "PayrollCalculationDetail",
  "EmploymentStatuses",
  "BasicPlanDetails",
  "PlanAdministrator",
  "Contact",
  //"Sources",
  "EmployeeDeferralSource",
  "Source",
  //"Sponsors",
  "Name",
  "ContactDetails",
  //"Trustees",
  "Trustee",
  //"ContactDetails"
];
const VerifyMapContainer = (props) => {
  const { state, dispatch } = useContext(manageMapperStore);
  const { flow, profileId, mapType } = useRouterParams();
  const [res, setRes] = useState([]);
  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      link: ROUTES.MAPPER_HOME,
    },
    {
      label: "Next",
      variant: "primary",
      type: "submit",
      link: getPathWithParam({
        path: `${MANAGE_MAPPER_ROUTES.FILTER}`,
        pathParam: [flow, mapType, profileId],
      }),
    },
  ];
  const columns = [
    {
      label: "Target fields",
      columnName: "propertyName",
      className: "column-frequency",
    },
    {
      label: "Source data",
      columnName: "propertyValue",
      className: "column-frequency",
    },
  ];

  const srcColumns = [
    {
      label: "Target fields",
      columnName: "propertyName",
      className: "column-frequency-source",
    },
    {
      label: "Source data",
      columnName: "propertyValue",
      className: "column-frequency",
    },
  ];

  const id = get(state, "profileId")
    ? parseInt(get(state, "profileId"))
    : get(state, "api.data.id");
  const { response, loading } = useRequest({
    method: verifyMapService,
    payload: id,
  });
  // useEffect(() => {
  //   if (!isNull(response)) {
  //     if (response[0].propertyName == "Error") {
  //       dispatch({
  //         type: MANAGE_MAPPER_POST_API_ERROR,
  //         payload: "Something went wrong! please try again.",
  //       });
  //     }
  //   }
  // }, [response]);

  const renderNestedProperties = (source, index) => {
    return (
      <>
        <div
          style={{
            fontWeight: "bold",
            padding: "10px",
            borderBottom: "1px solid #ccc",
            marginTop: "5px",
          }}
        >
          <span className="ml-4">{source.propertyName}</span>
        </div>

        {!isEmpty(source.propertyValue) &&
          isArray(source.propertyValue) &&
          source.propertyValue.map((e, i) =>
            isArray(e["propertyValue"]) ? (
              renderNestedProperties(e, `${index}-${i}`)
            ) : (
              <Table.Tr
                key={`${index}-${i}`}
                style={{
                  borderBottom: "1px solid #ccc",
                  padding: "5px",
                  marginTop: "5px",
                }}
              >
                {srcColumns.map((item, cellIndex) => (
                  <Table.Td key={cellIndex} className={item.className}>
                    {e[item.columnName]}
                  </Table.Td>
                ))}
              </Table.Tr>
            )
          )}
      </>
    );
  };

  return (
    <ManageMapperLayout buttons={buttons}>
      {console.log("resdfg", response)}
      <LoaderWrapper isLoading={loading}>
        <div className="mapper-container">
          <Table>
            <Table.Thead>
              <Table.Tr>
                {columns.map((item, index) => {
                  return (
                    <Table.Th key={index} className={item.className}>
                      {item.label}
                    </Table.Th>
                  );
                })}
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {console.log("432", response)}
              {response?.map((source, index) => {
                if (
                  source.propertyName == "Name" &&
                  isArray(source.propertyValue)
                ) {
                  return renderNestedProperties(source, index);
                } else if (
                  propertyNames.includes(source.propertyName) &&
                  isArray(source.propertyValue)
                ) {
                  return renderNestedProperties(source, index);
                }
                return (
                  <Table.Tr
                    key={index}
                    style={{
                      borderBottom: "1px solid #ccc",
                      padding: "5px",
                      marginTop: "5px",
                    }}
                  >
                    {columns.map((item, cellIndex) => {
                      return (
                        <Table.Td key={cellIndex} className={item.className}>
                          {source[item.columnName]}
                        </Table.Td>
                      );
                    })}
                  </Table.Tr>
                );
              })}
            </Table.Tbody>
          </Table>
        </div>
      </LoaderWrapper>
    </ManageMapperLayout>
  );
};

export default VerifyMapContainer;
